import { Component, Input } from "@angular/core";

@Component({
    selector: "control-message",
    templateUrl: "./control-message.component.html",
    styleUrls: ["./control-message.component.css"],
    standalone: true
})
export class ControlMessageComponent {

  @Input() message: any;

  constructor() {}
}
